import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlService } from '../http/url.service';
import { IAccountChat } from './account-chat';

@Injectable({
  providedIn: 'root'
})
export class ChatDataService {

  public constructor(private readonly http: HttpClient,
                     private readonly urlService: UrlService) { }

  public getChatInfo(): Observable<IAccountChat> {
    const url = this.urlService.buildServerApiUrl('Account', 'ChatInfo');

    return this.http.get<IAccountChat>(url);
  }
}
